<template>
  <v-dialog class="the-app-dialogs" v-model="addDialog" persistent max-width="700px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">fa-dolly</v-icon>
              <span class="px-3">{{ $t('Add New Product') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-layout row wrap>
              <v-flex xs12 sm4 class="pb-2">
                <v-layout row wrap justify-content-start>
                  <v-flex xs12>
                    <label @click="chooseImage" style="cursor:pointer">
                      <v-hover>
                        <v-card slot-scope="{ hover }" flat color="grey lighten-4" max-width="600">
                          <div
                            class="product-image"
                            :style="{
                              'background-image': `url(${imageData})`
                            }"
                          >
                            <span v-if="!imageData">
                              <v-img :src="`${baseUrls.images}/no-image-available.png`" height="235" />
                            </span>
                            <v-expand-transition>
                              <div
                                v-if="hover"
                                class="transition-fast-in-fast-out v-card--reveal white--text headline image-upload-overlay"
                              >
                                <div class="overlay-inner-content">
                                  {{ $t('Click To Upload') }}
                                </div>
                              </div>
                            </v-expand-transition>
                          </div>
                        </v-card>
                      </v-hover>
                    </label>
                  </v-flex>
                  <input
                    type="file"
                    name="product_image"
                    ref="fileInput"
                    style="visibility:hidden; width:0; position:absolute; top:-9999px"
                    v-validate="'size:2047|ext:jpeg,jpg,png'"
                    @input="onSelectFile"
                  />
                  <label @click="chooseImage" class="info white--text file-upload-trigger" ripple>{{
                    $t('Upload Image')
                  }}</label>
                </v-layout>
              </v-flex>

              <v-flex xs12 sm8>
                <v-layout row wrap justify-content-end>
                  <v-flex xs12 class="pb-2 px-2">
                    <v-text-field
                      id="product-focus-me"
                      v-model="form.theProductName"
                      :label="`${$t('Product Name')} *`"
                      name="product_name"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('product_name')"
                      v-validate="'required'"
                    />
                  </v-flex>

                  <v-flex xs6 class="pa-2">
                    <v-text-field
                      v-model="form.productBarcode"
                      :label="$t('Barcode')"
                      name="product_barcode"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('product_barcode')"
                    />
                  </v-flex>

                  <v-flex xs6 class="pt-2 px-2">
                    <v-text-field
                      v-model="form.salePrice"
                      :label="`${$t('Sale Price')} (${systemCurrency}) *`"
                      name="product_sale"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('product_sale')"
                      v-validate="'required|decimal:3|min_value:0'"
                      data-vv-delay="1000"
                    />
                  </v-flex>

                  <v-flex pa-2>
                    <v-autocomplete
                      v-model="form.productTypeIdFk"
                      :items="fullProductTypesList"
                      :label="`${$t('Product Type')}`"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('product_type')"
                      data-vv-name="product_type"
                      :menu-props="{ transition: 'slide-y-transition' }"
                    />
                  </v-flex>

                  <v-flex xs2 class="pt-2" v-if="hasPermissions(['product_types_store'])">
                    <v-tooltip top>
                      <v-btn label @click="$emit('add-product-type')" slot="activator" icon fab small color="green">
                        <v-icon color="white" size="25">add</v-icon>
                      </v-btn>
                      <span>{{ $t('Add new product type') }}</span>
                    </v-tooltip>
                  </v-flex>

                  <v-flex xs6 class="pa-2">
                    <v-text-field
                      v-model="form.quantityAlarm"
                      :label="$t('Quantity Alarm')"
                      name="quantity_alarm"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('quantity_alarm')"
                      v-validate="'integer'"
                    />
                  </v-flex>

                  <v-flex xs6 class="pt-2 px-2">
                    <v-text-field
                      v-model="form.quantityAlarmTotal"
                      :label="$t('Total Quantity Alarm')"
                      name="quantity_alarm_total"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('quantity_alarm_total')"
                      v-validate="'integer'"
                    />
                  </v-flex>

                  <!-- <v-flex xs12 class="pa-2">
                    <v-text-field
                      v-model="form.expiryAlarm"
                      :label="$t('Expiration Alarm (No. of days before expiration date)')"
                      name="expire_alarm"
                      box
                      hide-details
                      background-color="white"
                      :error="errors.has('expire_alarm')"
                      v-validate="'integer'"
                    />
                  </v-flex>-->
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout wrap>
              <v-flex xs12 pa-2>
                <v-text-field
                  v-model="form.brand_or_made_in"
                  :label="$t('Brand / Made In')"
                  name="brand_or_made_in"
                  box
                  hide-details
                  background-color="white"
                  :error="errors.has('brand_or_made_in')"
                />
              </v-flex>

              <v-flex xs6 px-2 style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBeSold"
                  :label="$t('Product Can Be Sold')"
                  name="can_be_sold"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_sold')"
                />
              </v-flex>

              <v-flex xs6 px-2 style="margin-bottom:-20px">
                <v-checkbox
                  v-model="form.canBePurchase"
                  :label="$t('Product Can Be Purchase')"
                  name="can_be_purchase"
                  true-value="1"
                  false-value="0"
                  color="primary"
                  box
                  :error="errors.has('can_be_purchase')"
                />
              </v-flex>

              <!-- <v-flex xs12 class="pa-2">
                <v-combobox
                  v-model="form.tags"
                  label="Product Tags"
                  chips
                  clearable
                  append-icon
                  box
                  hide-details
                  background-color="white"
                  multiple
                  :error="errors.has('product_tags')"
                  data-vv-name="product_tags"
                >
                  <template v-slot:selection="data">
                    <v-chip :selected="data.selected" close @input="removeTag(data.item)">
                      <strong>{{ data.item }}</strong>&nbsp;
                    </v-chip>
                  </template>
                </v-combobox>
              </v-flex>-->

              <v-flex xs12 class="pa-2">
                <v-textarea
                  v-model="form.productDescription"
                  :label="$t('Description')"
                  name="product_description"
                  box
                  hide-details
                  height="80"
                  background-color="white"
                  :error="errors.has('product_description')"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      systemCurrency: localStorage.systemCurrency,
      btnAddLoading: false,
      form: {
        canBeSold: '1',
        canBePurchase: '1',
        tags: []
      },
      imageData: null,
      imageInput: null,
      imageFile: null,
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      baseUrls: 'misc/getBaseUrls',
      fullProductTypesList: 'productTypes/getFullProductTypesList',
      sectionTitle: 'dashboard/getAppBarTitle',
      settings: 'configurations/getSystemSettings'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addProduct: 'products/addProduct'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      this.imageData = null
      this.imageInput = null
      this.imageFile = null
      this.$refs.fileInput.value = ''
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.canBeSold = '1'
      this.form.canBePurchase = '1'
      this.form.tags = []
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('product-focus-me').focus()
      })
    },

    chooseImage() {
      this.$refs.fileInput.click()
    },

    onSelectFile() {
      this.imageInput = this.$refs.fileInput
      this.imageFile = this.imageInput.files

      if (this.imageFile && this.imageFile[0]) {
        const reader = new FileReader()
        reader.onload = e => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(this.imageFile[0])
        this.$emit('input', this.imageFile[0])
      }
    },

    removeTag(item) {
      this.form.tags.splice(this.form.tags.indexOf(item), 1)
      this.form.tags = [...this.form.tags]
    },

    validateBeforeSubmit(event) {
      this.$validator.validateAll().then(() => {
        if (!this.errors.any()) {
          this.btnAddLoading = true

          let formData = new FormData(event.target)
          formData.append('can_be_sold', this.form.canBeSold)
          formData.append('can_be_purchase', this.form.canBePurchase)
          formData.append('product_type_id_fk', this.form.productTypeIdFk || '')
          // formData.append('product_tag[]', this.form.tags.join(',') || '')

          if (this.imageData != null) {
            formData.append('product_image', this.imageFile[0])
          }
          // for (let pair of formData.entries()) {
          //   console.warn(`${pair[0]}: ${pair[1]}`)
          // }

          this.addProduct(formData)
            .then(() => {
              this.btnAddLoading = false
              this.$emit('reset-datatable')
              if (this.keepForm) {
                this.resetForm()
              } else {
                this.$emit('hidemodal')
              }
            })
            .catch(() => {
              this.btnAddLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped />
